import { render, staticRenderFns } from "./WizardChooseRoleBtn.vue?vue&type=template&id=27508efb&scoped=true&"
import script from "./WizardChooseRoleBtn.vue?vue&type=script&lang=js&"
export * from "./WizardChooseRoleBtn.vue?vue&type=script&lang=js&"
import style0 from "./WizardChooseRoleBtn.vue?vue&type=style&index=0&id=27508efb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27508efb",
  null
  
)

export default component.exports